export const advancedSearchOptionStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 2,
		px: 2,
		py: 1,
		cursor: 'pointer'
	},
	iconContainer: {
		backgroundColor: 'primary.main',
		width: 40,
		height: 40,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '0 0 auto'
	},
	icon: {
		width: 15,
		height: 15
	}
};
